import e from "@dialpad/dialtone-tokens/layered/themes/tokens-solstice-colors.css?inline";
//#region themes/solstice.js
var t = {
	brand: {
		css: e,
		name: "solstice"
	},
	material: { name: "graphite" }
};
//#endregion
export { t as default };
